jQuery(document).ready(function () {
	"use strict";
 if (document.body.classList.contains("single-product")) {
	 var upsells = document.querySelectorAll("section.upsells .products li");
	 if (upsells.length > 3) {
		 jQuery("section.related").css("display", "none");
	 }
 }
});
